var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"two-columns product-controls"},[_c('button',{staticClass:"button primary product-detail-link",attrs:{"href":"#"}},[_vm._v("Details")]),_c('button',{staticClass:"button action add-to-cart",attrs:{"href":"#"}},[_vm._v("Add to Cart")])])
}]

export { render, staticRenderFns }